// src/components/shared/PageErrorBoundary.js
// Granular error boundary for route-level crash recovery.
// Wraps page content so Header/Footer survive errors.

import React, { Component } from "react";
import * as Sentry from "@sentry/react";

class PageErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, {
      extra: { componentStack: errorInfo.componentStack },
    });
  }

  handleReset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: "40px 20px",
            textAlign: "center",
            maxWidth: "500px",
            margin: "60px auto",
          }}
        >
          <h2 style={{ margin: "0 0 12px", fontSize: "20px", color: "#1a1a1a" }}>
            Something went wrong
          </h2>
          <p style={{ color: "#666", fontSize: "14px", marginBottom: "24px" }}>
            This page encountered an error. The rest of the app is still working.
          </p>
          <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
            <button
              onClick={this.handleReset}
              style={{
                padding: "10px 24px",
                background: "#3b82f6",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Try Again
            </button>
            <button
              onClick={() => (window.location.href = "/")}
              style={{
                padding: "10px 24px",
                background: "#f3f4f6",
                color: "#374151",
                border: "none",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Go Home
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default PageErrorBoundary;
